import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { expenseEntryInitialsForAdd } from '../interfaces/expenseClass';
import { getExpenseSheetByAccountEmployeeIdAsync, setOptionEmployeeNameValue, setDateRangeValue, resetSelectedRecordObjectInState } from '../expenseSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import Select, { StylesConfig } from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import ExpenseSheet from './ExpenseSheet';
import { DateRangePicker } from 'rsuite';
import { format, parseISO } from 'date-fns';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import DatePickerRanges from '../../../common/DatePickerRanges';


const ExpenseSearchForm = (props: any) => {
    const { modelRef, t } = props;
    const { sessionAccountEmployeeId, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector(state => state.globalState);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expenseEntryInitialsForAdd);
    const { expenseSheetList, isReload, selectedRecord, isLoading, startDate, endDate } = useAppSelector((state) => state.expense);
    const dispatch = useAppDispatch();
    const [isChecked, setIsChecked] = useState(false);
    const [selectedOptionEmployee, setSelectedOptionEmployee] = useState<{ [object: string]: any }>();
    const [EmployeeArray, SetEmployeeArray] = useState<any | ''>([]);
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(currentDate);
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
    const [selectedOptionStatus, setSelectedOptionStatus] = useState({ label: 'All Expenses', value: 0 });
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const options = [
        { label: getValueFromResource('All Expenses', dispatch, t), value: 0 },
        { label: getValueFromResource('All Open Expenses', dispatch, t), value: 1 },
        { label: getValueFromResource('Not Submitted', dispatch, t), value: 2 },
        { label: getValueFromResource('Submitted', dispatch, t), value: 3 },
        { label: getValueFromResource('Approved', dispatch, t), value: 4 },
        { label: getValueFromResource('Rejected', dispatch, t), value: 5 }
    ];
const [amountCondition, setAmountCondition] = useState({ label: 'Select Condition', value: '' });
const [amountValue, setAmountValue] = useState<string>('');
const amountConditionOptions = [
    { label: getValueFromResource('None', dispatch, t), value: '' },
    { label: getValueFromResource('Greater Than (>)', dispatch, t), value: '>' },
    { label: getValueFromResource('Less Than (<)', dispatch, t), value: '<' },
    { label: getValueFromResource('Equal To (=)', dispatch, t), value: '=' },
    { label: getValueFromResource('Greater Than or Equal To (>=)', dispatch, t), value: '>=' },
    { label: getValueFromResource('Less Than or Equal To (<=)', dispatch, t), value: '<=' }
];

    const getEmployees = async () => {
        const response = await fetchAPI('api/V2/ExpenseSheets/GetAccountEmployeesForExpenseSheet', "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.AccountEmployeeId;
            item.label = item.EmployeeName;
            delete item.AccountEmployeeId;
            delete item.EmployeeName;
        });
        SetEmployeeArray(json);
    }

    useEffect(() => {
        getEmployees();

    }, []);

    useEffect(() => {
        const index = EmployeeArray.findIndex((item: any) => item.value === sessionAccountEmployeeId);
        if (index !== -1) {
            setSelectedOptionEmployee(EmployeeArray[index]);
        }
    }, [sessionAccountEmployeeId, EmployeeArray]);

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    // const handleSubmit = () => {
    //     const AccountEmployeeId = selectedOptionEmployee === null || selectedOptionEmployee === undefined ? 0 : selectedOptionEmployee?.value;
    //     const ExpenseSheetStatusId = selectedOptionStatus?.value === null || selectedOptionStatus?.value === undefined ? 0 : selectedOptionStatus?.value;
    //     const StartDate = moment(startDate).format(dateInsertionFormat);
    //     const EndDate = moment(endDate).format(dateInsertionFormat);
    //     const IncludeDateRange = isChecked;
    //     dispatch(getExpenseSheetByAccountEmployeeIdAsync({ AccountEmployeeId, ExpenseSheetStatusId, IncludeDateRange, StartDate, EndDate }));
    //     if (closeButtonRef.current) {
    //         closeButtonRef.current.click();
    //     }
    // }
    const handleSubmit = () => {
    const AccountEmployeeId = selectedOptionEmployee === null || selectedOptionEmployee === undefined ? 0 : selectedOptionEmployee?.value;
    const ExpenseSheetStatusId = selectedOptionStatus?.value === null || selectedOptionStatus?.value === undefined ? 0 : selectedOptionStatus?.value;
    const StartDate = moment(startDate).format(dateInsertionFormat);
    const EndDate = moment(endDate).format(dateInsertionFormat);
    const IncludeDateRange = isChecked;
    
    const AmountCondition = amountCondition?.value || '';
    const Amount = amountValue ? parseFloat(amountValue) : null;
    dispatch(getExpenseSheetByAccountEmployeeIdAsync({ 
        AccountEmployeeId, 
        ExpenseSheetStatusId, 
        IncludeDateRange, 
        StartDate, 
        EndDate,
        AmountCondition,
        Amount 
    }));

    if (closeButtonRef.current) {
        closeButtonRef.current.click();
    }
}
   
   

    const handleChangeEmployees = (selectedOption: any) => {
        setSelectedOptionEmployee(selectedOption);
    };
    const handleChangeStatus = (selectedOption: any) => {
        setSelectedOptionStatus(selectedOption);
    };

    const handleCheckboxChange = (event: any) => {
        setIsChecked(event.target.checked);
    };


    const handleDateRangeChange = (value: any) => {
        // setSelectedStartDate(value[0]);
        // setSelectedEndDate(value[1]);
        // dispatch(setDateRangeValue({ startDate: value[0].toISOString(), endDate: value[1].toISOString() }))
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // setSelectedStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        // setSelectedEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        // dispatch(setDateRangeValue({ startDate: dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate: dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()) }));
        setSelectedStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setSelectedEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
        dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
    };

    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                {/* <div className='col-md-12'>


                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">
                           
                            {getValueFromResource('Date Range', dispatch, t)}
                        </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges()}
                                value={[SelectedStartDate, SelectedEndDate]}
                               
                                placeholder={displayedRange}
                                cleanable={false}
                                character={' - '}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div> */}
             
    <div className='col-md-12'>
        
        <div className="d-flex align-items-center justify-content-between mb-2">
            <label className="fs-7 fw-normal m-0">
                {getValueFromResource('Date Range', dispatch, t)}
            </label>
            <div className="form-check form-check-custom form-check-solid gap-2">
                <input
                    className="form-check-input h-15px w-15px"
                    type="checkbox"
                    id="includeDateRange"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                />
                <label className="fs-8 fw-normal text-muted cursor-pointer" htmlFor="includeDateRange">
                    {getValueFromResource('Include Date Range', dispatch, t)}
                </label>
            </div>
        </div>
        <div>
            <DateRangePicker
                onChange={handleDateRangeChange}
                ranges={DatePickerRanges()}
                value={[SelectedStartDate, SelectedEndDate]}
                placeholder={displayedRange}
                cleanable={false}
                character={' - '}
                placement="bottomEnd"
                disabled={!isChecked} 
                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
            />
        </div>
    </div>

                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionEmployee}
                            id="AccountEmployeeId"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="AccountEmployeeId"
                            onChange={handleChangeEmployees}
                            options={EmployeeArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            {/* {t('Approval Status')} */}
                            {getValueFromResource('Approval Status', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionStatus}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="ExpenseSheetStatusId"
                            onChange={handleChangeStatus}
                            options={options}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />

                    </div>
                </div>
                {/* <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">
                            
                            {getValueFromResource('Include Date Range', dispatch, t)}
                        </label>
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input
                                className="form-check-input h-20px w-30px mt-1"
                                type="checkbox"
                                style={{ marginTop: '-20px' }}
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                            />
                        </div>
                    </div>
                </div> */}
<div className='row spacingBetweenRows'>
    <div className="col-md-12">
        <label className="fs-7 fw-normal mb-2">
            {getValueFromResource('Amount Filter', dispatch, t)}
        </label>        
        <div className="d-flex gap-2 w-100">
            <div style={{ width: '60%' }}>
                <Select
                    value={amountCondition}
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={false}
                    name="AmountCondition"
                    onChange={(option: any) => {
                        setAmountCondition(option);
                        if (!option || option.value === '') {
                            setAmountValue('');
                        }
                    }}
                    options={amountConditionOptions}
                    styles={dropDownSelectionStyles}
                    maxMenuHeight={maxMenuHeight}
                />
            </div>
            <div style={{ width: '45%' }}>
                <input
                    type="number"
                    className="form-control fs-7"
                    style={{ 
                        height: '38px', 
                        backgroundColor: amountCondition?.value ? '#ffffff' : '#f5f8fa',
                        color: '#3f4254'
                    }}
                    placeholder={getValueFromResource('Enter Amount', dispatch, t)}
                    value={amountValue}
                    disabled={!amountCondition?.value}
                    onChange={(e) => setAmountValue(e.target.value)}
                />
            </div>
        </div>
    </div>
</div>
            </div>

            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                        // id="kt_OffCanvas"
                        id='kt_OffCanvas_close'
                    >
                        {/* {t('Cancel')}  */}
                        {getValueFromResource('Cancel', dispatch, t)}
                    </button>

                    <button
                        type="button"
                        data-kt-element='send'
                        className="btn btn-primary btn-sm fs-7"
                        onClick={() => handleSubmit()}
                    >
                        {/* {t('Apply Filters')} */}
                        {getValueFromResource('Apply Filters', dispatch, t)}
                    </button>
                   
                </div>
            </div>




        </>

    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default ExpenseSearchForm